// Admin API client
import { api } from './client';

interface AdminUser {
  id: string;
  email: string;
  name: string;
  role: 'super_admin' | 'project_admin' | 'editor' | 'viewer';
  is_active: number;
  created_at: string;
}

interface AdminProject {
  id: string;
  name: string;
  owner_id: string;
  owner_name: string;
  owner_email: string;
  is_public: number;
  layer_count: number;
  created_at: string;
}

interface AdminTransaction {
  id: string;
  type: 'guest_query' | 'subscription';
  tier: string | null;
  amount: number;
  status: 'pending' | 'confirmed' | 'expired' | 'failed';
  user_email: string | null;
  user_name: string | null;
  created_at: string;
  confirmed_at: string | null;
}

interface SystemConfig {
  key: string;
  value: string;
  updated_at: string;
}

export const adminApi = {
  listUsers: () => api<{ items: AdminUser[] }>('/api/admin/users'),
  updateUserRole: (id: string, role: string) =>
    api<{ success: boolean }>(`/api/admin/users/${id}/role`, { method: 'PATCH', body: JSON.stringify({ role }) }),
  deleteUser: (id: string) =>
    api<{ success: boolean }>(`/api/admin/users/${id}`, { method: 'DELETE' }),

  listAllProjects: () => api<{ items: AdminProject[] }>('/api/admin/projects'),

  getConfig: () => api<{ items: SystemConfig[] }>('/api/admin/config'),
  setConfig: (key: string, value: string) =>
    api<{ success: boolean }>(`/api/admin/config/${key}`, { method: 'PUT', body: JSON.stringify({ value }) }),

  listTransactions: () => api<{ items: AdminTransaction[] }>('/api/admin/transactions'),
  getRevenue: () => api<{
    guestRevenue: number;
    subscriptionRevenue30d: number;
    guestCount: number;
    subCount: number;
  }>('/api/admin/revenue'),

  getPublicConfig: () => api<Record<string, string>>('/api/admin/public-config'),
};
